import React from 'react'
import SecondaryCatalogueViewTemplate from '../../templates/SecondaryCatalogue/SecondaryCatalogueView.template'

const SecondaryCatalogueView: React.FC = () => {
	return (
		<SecondaryCatalogueViewTemplate />
	)
}
export default SecondaryCatalogueView